import Cookies from 'js-cookie';
import { type PersonalizationType } from '../../../netlify/edge-functions/lib/types';
import { A_B_TEST_COUNTRY_COOKIE_NAME } from '../../../netlify/edge-functions/lib/constants';
import {
  getUtmParams,
  isUserAgentMobile,
} from '../../../netlify/edge-functions/lib/shared-functions';

type FirstPartyDataList = Record<PersonalizationType, string>;

/*
 * NOTE A counterpart of this function for serverless exists in: @/netlify/edge-functions/a-b-test.ts
 */
const getFirstPartyData = (): FirstPartyDataList => {
  const url = new URL(window.location.href);
  const countryCode = Cookies.get(A_B_TEST_COUNTRY_COOKIE_NAME) || '';
  const isMobile = isUserAgentMobile(window.navigator.userAgent);

  return {
    country: countryCode,
    device: isMobile ? 'mobile' : 'desktop',
    ...getUtmParams(url),
  };
};

export default getFirstPartyData;
